import type { Point } from '@ikegps/core-api';
import type { IkeDraw } from '../draw';

export interface ZoomEvent {
	delta: number;
	center?: Point;
	$event: MouseEvent;
}

export const MAX_ZOOM_LEVEL = 14;
export const MIN_ZOOM_LEVEL = 1;
export const START_ZOOM_LEVEL = 1;

export function imageZoomBinding(dc: IkeDraw, evt: ZoomEvent) {
	const startZoom = dc.state.zoom || START_ZOOM_LEVEL;
	const delta = evt.delta;

	let currentZoom = startZoom * delta;
	if (currentZoom < MIN_ZOOM_LEVEL) {
		currentZoom = MIN_ZOOM_LEVEL;
	} else if (currentZoom > MAX_ZOOM_LEVEL) {
		currentZoom = MAX_ZOOM_LEVEL;
	}
	currentZoom = Math.round(currentZoom * 100) / 100;
	if (currentZoom === startZoom) {
		return;
	}

	const mousePoint = evt.center;
	if (mousePoint != null) {
		const currentX = dc.state.centerX;
		const currentY = dc.state.centerY;
		const diffX = mousePoint.x - dc.state.centerX;
		const nextX = diffX * delta;

		const diffY = mousePoint.y - dc.state.centerY;
		const nextY = diffY * delta;

		dc.state.setZoom(currentZoom, currentX + nextX - diffX, currentY + nextY - diffY);
	} else {
		dc.state.setZoom(currentZoom);
	}

	if (evt.$event != null) {
		evt.$event.preventDefault();
	}
}
